import { forwardRef, type Ref, type SVGProps } from "react";
const IconCollapseOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M2.963 17.963c0 .6.4 1 1 1h7.6l-9.3 9.3c-.4.4-.4 1 0 1.4s1 .4 1.4 0l9.3-9.3v7.6c0 .6.4 1 1 1s1-.4 1-1v-10c0-.6-.4-1-1-1h-10c-.6 0-1 .5-1 1m25.3-15.701-9.3 9.3v-7.6c0-.6-.4-1-1-1s-1 .4-1 1v10c0 .6.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1h-7.6l9.3-9.3c.4-.4.4-1 0-1.4-.4-.3-1-.3-1.4 0"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCollapseOutlineSVG);
ForwardRef.displayName = "IconCollapseOutline";
export { ForwardRef as IconCollapseOutline };
